// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Form-module--bx--text-truncate--end--dtWcC";
export var bxTextTruncateFront = "Form-module--bx--text-truncate--front--4ueGY";
export var dialog = "Form-module--dialog--qEQDG";
export var enter = "Form-module--enter--REimb";
export var enterActive = "Form-module--enterActive--v3cmy";
export var exit = "Form-module--exit--h-z2C";
export var exitActive = "Form-module--exitActive--7Dm++";
export var formContainer = "Form-module--form-container--6eZKL";
export var buttonRow = "Form-module--buttonRow--6FhRn";
export var button = "Form-module--button--hm-9B";